import { dimensionById } from './dimensions';
import { isEvaluable, type FilterChip } from './filters';
import type { RosterDomainKey } from './rosterRows';

export type EvidenceColumnId =
  | 'yearsInEl'
  | 'compositePL'
  | RosterDomainKey
  | 'dataQuality'
  | 'signOffs';

export const EVIDENCE_ORDER: readonly EvidenceColumnId[] = [
  'yearsInEl',
  'compositePL',
  'listening',
  'speaking',
  'reading',
  'writing',
  'dataQuality',
  'signOffs',
];

const TENURE_COHORTS = new Set(['ltel']);

function requestedBy(chip: FilterChip): string[] {
  if ('values' in chip) {
    if (chip.dimension === 'cohort') {
      const columns: EvidenceColumnId[] = [];
      if (chip.values.some((value) => TENURE_COHORTS.has(value))) columns.push('yearsInEl');
      return columns;
    }
    const declared = dimensionById(chip.dimension)?.evidenceColumn;
    return declared == null ? [] : [declared];
  }
  if (!isEvaluable(chip)) return [];
  if (chip.dimension === 'domainPL') return chip.domain == null ? [] : [chip.domain];
  const declared = dimensionById(chip.dimension)?.evidenceColumn;
  return declared == null ? [] : [declared];
}

export function evidenceColumnsFor(chips: FilterChip[]): EvidenceColumnId[] {
  const requested = new Set(chips.flatMap(requestedBy));
  return EVIDENCE_ORDER.filter((id) => requested.has(id));
}
